import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";
import DeliverySection from "./DeliverySection";
import Select from "react-select";
import JoditEditor from "jodit-react";
import Header from "../../Header/Header";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import PlanPriceSection from "./PlanPriceSection";
import { useWatch } from "react-hook-form";
library.add(fas);

const EditOffCanvance = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  // const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/admin/subscription/plan/${id}`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    trigger,
    watch,
    setValue,
  } = useForm();
  // console.log(getValues("id"),":getval");
  const imageFile = watch("image");
  // const navigate = useNavigate();
  const onSubmit = async (data) => {
    // const hasEmptyDelivery = data.weeks.some((week) =>
    //   week.deliveries.some(
    //     (delivery) =>
    //       !delivery.days_id ||
    //       !delivery.products ||
    //       delivery.products.length === 0
    //   )
    // );

    // if (hasEmptyDelivery) {
    //   alert("Each delivery must have selected days and at least 1 product.");
    //   return;
    // }
    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data.name);
      DataToSend.append("sub_name", data.sub_name);
      DataToSend.append("term_condition", data.term_condition);
      if (data.plan_feture_id) {
        DataToSend.append(
          "plan_feture_id",
          JSON.stringify(data.plan_feture_id.map((option) => option.value))
        );
      }

      if (data?.image?.length > 0) {
        DataToSend.append("image", data.image[0]);
      }

      // Intake Direction
      const intake_direction = [];
      data?.intake_direction?.forEach((item, index) => {
        intake_direction.push({
          id: item.id,
          name: item.name,
          sub_name: item.sub_name,
        });

        // if (
        //   item?.image &&
        //   Array.isArray(item.image) &&
        //   item.image[0] instanceof File
        // ) {
        //   DataToSend.append(`intake_image${index}`, item.image[0]);
        // }
      });
      DataToSend.append("intake_direction", JSON.stringify(intake_direction));

      // Nutritions
      const nutritions =
        data.nutritions?.map((item) => ({ name: item.name })) || [];
      DataToSend.append("nutritions", JSON.stringify(nutritions));

      // Plan Prices
      const plan_price =
        data.plan_price?.map((item) => ({
          duration: item.duration,
          price: item.price,
          mrp: item.mrp,
        })) || [];
      DataToSend.append("plan_price", JSON.stringify(plan_price));

      // Weeks + Deliveries
      // const weeks = [];
      // data.weeks?.forEach((week, wIndex) => {
      //   const weekObj = {
      //     week_id: week.week_id,
      //     days_id: week.days_id?.map((day) => day.value) || [],
      //     deliveries: [],
      //   };

      //   week.deliveries?.forEach((delivery, dIndex) => {
      //     weekObj.deliveries.push({
      //       week_id: week.week_id,
      //       duration: delivery.duration,
      //       price: delivery.price,
      //       category_id: delivery.category_id?.value,
      //       product_id: delivery.product_id?.value,
      //       quantity: delivery.quantity,
      //       calories: delivery.calories,
      //       serving_size: delivery.serving_size,
      //     });
      //   });

      //   weeks.push(weekObj);
      // });
      // DataToSend.append("weeks", JSON.stringify(weeks));
      const weeks = [];

      data.weeks?.forEach((week) => {
        const weekObj = {
          week_id: week.week_id,

          deliveries: [],
        };

        week.deliveries?.forEach((delivery) => {
          const deliveryObj = {
            week_id: week.week_id,
            delivery_id: delivery.delivery_id,
            days_id: delivery.days_id?.map((day) => day.value) || [],
            products: [],
          };

          delivery.products?.forEach((product) => {
            deliveryObj.products.push({
              week_id: week.week_id,
              delivery_id: delivery.delivery_id,
              id: product.product_id,
              category_id: product.category_id?.value,
              product_id: product.product_id?.value,
              variant_id: product.variant_id?.value,
              quantity: product.quantity,
              calories: product.calories,
              serving_size: product.serving_size,
            });
          });

          weekObj.deliveries.push(deliveryObj);
        });

        weeks.push(weekObj);
      });

      DataToSend.append("weeks", JSON.stringify(weeks));

      const response = await putData(
        `/admin/subscription/plan/${id}`,
        DataToSend
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        navigate("/subscription/plans");
        // props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "plan_price",
  });

  const {
    fields: weekFields,
    append: appendWeek,
    remove: removeWeek,
  } = useFieldArray({
    control,
    name: "weeks",
  });
  const {
    fields: intakeDirectionFields,
    append: appendIntakeDirection,
    remove: removeIntakeDirection,
  } = useFieldArray({
    control,
    name: "intake_direction",
  });

  const {
    fields: nutritionFields,
    append: appendNutrition,
    remove: removeNutrition,
  } = useFieldArray({
    control,
    name: "nutritions",
  });

  const [days, setDays] = useState([]);
  const getAllDays = async () => {
    const response = await getData("/common/masters/all-days");
    if (response?.success) {
      setDays(await Select2Data(response?.data, "day_id"));
    }
  };

  const [planFeture, setPlanFeture] = useState([]);
  const getPlanFeture = async () => {
    const response = await getData("/common/masters/all-plan-feture");
    if (response?.success) {
      setPlanFeture(await Select2Data(response?.data, "plan_feture_id"));
    }
  };
  useEffect(() => {
    getAllDays();
    getPlanFeture();
  }, []);

  // const watchedWeeks = watch("weeks");
  const planPriceValues = watch("plan_price") || [];

  const [onchageValue, setOnchangeValue] = useState(true);
  const [total_price, settotal_price] = useState();
  // useEffect(() => {
  //   // const total = (watchedWeeks || []).reduce((weekAcc, week) => {
  //   //   return (
  //   //     weekAcc +
  //   //     (week.deliveries || []).reduce((deliveryAcc, delivery) => {
  //   //       return (
  //   //         deliveryAcc +
  //   //         (delivery.products || []).reduce((prodAcc, product) => {
  //   //           const price = parseFloat(product.variant_id?.price || 0);
  //   //           const quantity = parseFloat(product.quantity || 0);
  //   //           return prodAcc + price * quantity;
  //   //         }, 0)
  //   //       );
  //   //     }, 0)
  //   //   );
  //   // }, 0);

  //   let total = 0;
  //   let quantity = 0;
  //   console.log(total_price,"total_price total_price iiiiiiiiiiiiiin");
  //   watch("weeks").forEach((item, index) => {
  //     item?.deliveries.forEach((del, delIndex) => {
  //       del?.products.forEach((product, proindex) => {
  //         total += parseFloat(product?.variant_id?.price || 0);
  //         quantity += Number(product.quantity || 0);
  //         // const subscription = watch((value, { name }) => {
  //           // console.log(name, "nameeee");

  //           // if (name === `weeks.${index}.deliveries.${index}.products`) {
  //           settotal_price(total*quantity);
  //           // }
  //         // });
  //         // return () => subscription.unsubscribe();
  //       });
  //     });
  //   });
  //   console.log(quantity,"quantity");
    
  // }, [watch,watch("weeks")]);


   const watchedWeeks = useWatch({
    control,
    name: "weeks", 
  });

  useEffect(() => {
    let total = 0;

    (watchedWeeks || []).forEach((week) => {
      (week?.deliveries || []).forEach((delivery) => {
        (delivery?.products || []).forEach((product) => {
          const price = parseFloat(product?.variant_id?.price || 0);
          const quantity = Number(product?.quantity || 0);
          total += price * quantity;
        });
      });
    });

    settotal_price(total);
  }, [watchedWeeks]);
 
  const [highestPrice, setHighestPrice] = useState(0);
  const [highestDuration, setHighestDuration] = useState(0);

  useEffect(() => {
    let maxDuration = 0;
    let maxPrice = 0;

    planPriceValues.forEach((item, index) => {
      const duration = Number(item.duration) || 0;
      const calculatedPrice = Number(
        (parseFloat(getValues(`plan_price.${index}.duration`)) *
          parseFloat(total_price)) /
          Number(highestDuration / 4)
      ).toFixed(2);

      setValue(`plan_price.${index}.price`, calculatedPrice);

      if (duration > maxDuration) {
        maxDuration = duration;
      }
    });

    setHighestDuration(maxDuration*4);
  }, [planPriceValues]);

  return (
    <>
      <Header title={"Edit Plan"} link={"#"} />
      <section className="Create">
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/subscription/plans`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>

        <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
          <Row className="">
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Plan</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Plan Name..."
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      {...register("name", {
                        required: "Plan Name is required",
                        validate: (value) =>
                          value.length <= 200 ||
                          "Data must be 200 characters or less",
                      })}
                    />
                  </InputGroup>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </Form.Group>
              </div>
            </Col>
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Plan Sub Title</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Plan Name..."
                      className={classNames("", {
                        "is-invalid": errors?.sub_name,
                      })}
                      {...register("sub_name", {
                        required: "Plan Sub Name is required",
                        validate: (value) =>
                          value.length <= 200 ||
                          "Data must be 200 characters or less",
                      })}
                    />
                  </InputGroup>
                  {errors.sub_name && (
                    <span className="text-danger">
                      {errors.sub_name.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Image</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="file"
                      name="image"
                      placeholder="Image"
                      className={classNames("", {
                        "is-invalid": errors?.image,
                      })}
                      {...register("image", {
                        // required: "Image is required",
                      })}
                      accept="image/*"
                      // onChange={handleImageChange}
                    />
                  </InputGroup>
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </Form.Group>
                {typeof getValues("image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  )
                )}
              </div>
            </Col>

            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>Plan Feture</Form.Label>
                  </div>
                  <InputGroup>
                    <Controller
                      name="plan_feture_id"
                      {...register("plan_feture_id", {
                        required: "Select Plan Feture",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isMulti
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.plan_feture_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={planFeture}
                        />
                      )}
                    />
                  </InputGroup>
                  {errors.plan_feture_id && (
                    <span className="text-danger">
                      {errors.plan_feture_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>
            <Col md={12}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Term Condition</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Controller
                        name="term_condition"
                        control={control}
                        rules={
                          {
                            // required: "Content is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }
                        } // Correct the maxLength rule
                        render={({ field: { onChange, onBlur, value } }) => (
                          <JoditEditor
                            value={value}
                            onBlur={() => {
                              onBlur();
                              trigger("term_condition");
                            }}
                            onChange={onChange}
                          />
                        )}
                      />
                    </InputGroup>
                    {errors.term_condition && (
                      <span className="text-danger">
                        {errors.term_condition.message}
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
            <div className="oder-detail-holder mt-3 mb-3">
              <div className="heading-holder">
                <h6>Plan Price</h6>
              </div>

              <div className="package-details-section">
                {fields.map((variant, index) => (
                  <PlanPriceSection
                    watch={watch}
                    fields={fields}
                    variant={variant}
                    index={index}
                    remove={remove}
                    highestDuration={highestDuration}
                    setHighestPrice={setHighestPrice}
                    setHighestDuration={setHighestDuration}
                    planPriceValues={planPriceValues}
                    watchedWeeks={watchedWeeks}
                    total_price={total_price}
                    settotal_price={settotal_price}
                    weekIndex={index}
                    control={control}
                    register={register}
                    getValues={getValues}
                    errors={errors}
                    setValue={setValue}
                  />
                  // <div key={variant.id} className="main-form-section mt-3">
                  //   <Row>
                  //     <Col md={4}>
                  //       <Form.Group>
                  //         <Form.Label>Duration (in Month)</Form.Label>
                  //         <Form.Control
                  //           type="text"
                  //           placeholder="Duration"
                  //           {...register(`plan_price.${index}.duration`, {
                  //             required: "Duration is required",
                  //           })}
                  //         />
                  //       </Form.Group>
                  //     </Col>

                  //     <Col md={4}>
                  //       <Form.Group>
                  //         <Form.Label>Price</Form.Label>
                  //         <Form.Control
                  //           type="text"
                  //           placeholder="Price"
                  //           {...register(`plan_price.${index}.price`, {
                  //             required: "Price is required",
                  //           })}
                  //           readOnly
                  //         />
                  //       </Form.Group>
                  //     </Col>

                  //     <Col md={4}>
                  //       <Form.Group>
                  //         <Form.Label>MRP</Form.Label>
                  //         <Form.Control
                  //           type="text"
                  //           placeholder="MRP"
                  //           {...register(`plan_price.${index}.mrp`, {
                  //             required: "MRP is required",
                  //           })}
                  //         />
                  //       </Form.Group>
                  //     </Col>
                  //   </Row>

                  //   {fields.length > 1 && (
                  //     <button
                  //       type="button"
                  //       className="btn btn-danger mt-3"
                  //       onClick={() => remove(index)}
                  //     >
                  //       Remove Plan Price
                  //     </button>
                  //   )}

                  //   <hr />
                  // </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => append({})}
                >
                  + Add Plan Price
                </button>
              </div>
            </div>

            {getValues("id") !== 3 && (
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6>Weeks</h6>
                </div>

                <div className="package-details-section">
                  {Array(highestDuration)
                    .fill(0)
                    .map((_, index) => (
                      <div className="mb-4 p-3 border">
                        <h5>Week {index + 1}</h5>
                        <DeliverySection
                          onchageValue={onchageValue}
                          setOnchangeValue={setOnchangeValue}
                          planPriceValues={planPriceValues}
                          watchedWeeks={watchedWeeks}
                          total_price={total_price}
                          settotal_price={settotal_price}
                          weekIndex={index}
                          control={control}
                          register={register}
                          getValues={getValues}
                          errors={errors}
                          setValue={setValue}
                          watch={watch}
                        />
                      </div>
                    ))}
                  {/* {weekFields.map((week, index) => (
                    <div key={week.id} className="mb-4 p-3 border">
                      <h5>Week {index + 1}</h5>
                      <DeliverySection
                        weekIndex={index}
                        control={control}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      />
                      <button
                        type="button"
                        className="btn btn-danger "
                        onClick={() => removeWeek(index)}
                      >
                        Remove Week
                      </button>
                    </div>
                  ))} */}
                </div>
                {/* <div className="text-center">
                  <button
                    type="button"
                    className="add-varient mt-3"
                    onClick={() =>
                      appendWeek({
                        deliveries: [{ duration: "", price: "" }],
                      })
                    }
                  >
                    + Add Week
                  </button>
                  
                </div> */}
              </div>
            )}

            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>Nutrition</h6>
              </div>

              <div className="package-details-section">
                {nutritionFields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Name</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`nutritions.${index}.name`} // Register color for the variant
                                placeholder="Name"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.plan_price?.[index]?.name,
                                })}
                                {...register(`nutritions.${index}.name`, {
                                  required: "name is required",
                                  validate: (value) =>
                                    value.length <= 200 ||
                                    "Data must be 200 characters or less",
                                })}
                              />
                              {errors?.nutritions?.[index]?.name && (
                                <span className="text-danger">
                                  {errors.nutritions[index].name.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    {nutritionFields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => removeNutrition(index)} // Remove the variant
                      >
                        Remove Nutrition
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => appendNutrition({})}
                >
                  + Add Nutrition
                </button>
              </div>
            </div>
            <div className="oder-detail-holder mb-3">
              <div className="heading-holder">
                <h6>Intake Direction</h6>
              </div>

              <div className="package-details-section">
                {intakeDirectionFields.map((variant, index) => (
                  <div key={variant.id} className="main-form-section mt-3">
                    <Row>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Name</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`intake_direction.${index}.name`} // Register color for the variant
                                placeholder="Duration"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.intake_direction?.[index]?.name,
                                })}
                                {...register(`intake_direction.${index}.name`, {
                                  required: "Name is required",
                                  validate: (value) =>
                                    value.length <= 200 ||
                                    "Data must be 200 characters or less",
                                })}
                              />
                              {errors?.intake_direction?.[index]?.duration && (
                                <span className="text-danger">
                                  {
                                    errors.intake_direction[index].duration
                                      .message
                                  }
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Details</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="text"
                                name={`intake_direction.${index}.sub_name`} // Register color for the variant
                                placeholder="Duration"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.intake_direction?.[index]?.sub_name,
                                })}
                                {...register(
                                  `intake_direction.${index}.sub_name`,
                                  {
                                    required: "sub_name is required",
                                    validate: (value) =>
                                      value.length <= 200 ||
                                      "Data must be 200 characters or less",
                                  }
                                )}
                              />
                              {errors?.intake_direction?.[index]?.sub_name && (
                                <span className="text-danger">
                                  {
                                    errors.intake_direction[index].sub_name
                                      .message
                                  }
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      {/* <Col md={4}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Image</Form.Label>
                            <Form.Group>
                              <Form.Control
                                type="file"
                                name={`intake_direction.${index}.image`}
                                placeholder="Image"
                                className={classNames("", {
                                  "is-invalid":
                                    errors?.intake_direction?.[index]?.image,
                                })}
                                {...register(
                                  `intake_direction.${index}.image`,
                                  {
                                    validate: async (value) => {
                                      if (typeof value !== "string") {
                                        // const fileTypes = [
                                        //   "jpg",
                                        //   "png",
                                        //   "jpeg",
                                        // ];
                                        // const fileType =
                                        //   value[0].name?.split(".")[1];
                                        // if (!fileTypes.includes(fileType)) {
                                        //   return `please upload a valid file format. (${fileTypes})`;
                                        // }
                                        // const fileSize = Math.round(
                                        //   value[0].size / 1024
                                        // );
                                        // if (fileSize > 500) {
                                        //   return "file size must be lower than 500kb";
                                        // }
                                      }
                                    },
                                  }
                                )}
                                accept="image/*"
                                onChange={(e) =>
                                  handlevarientImageChange(e, index)
                                }
                              />
                              {errors?.intake_direction?.[index]?.image && (
                                <span className="text-danger">
                                  {errors.intake_direction[index].image.message}
                                </span>
                              )}
                              {(imagePreviewsvarient[index] ||
                                (variant.image &&
                                  !imagePreviewsvarient[index])) && (
                                <div className="mt-2">
                                  <img
                                    src={
                                      imagePreviewsvarient[index] ||
                                      IMG_URL + variant.image
                                    }
                                    alt="Project Preview"
                                    style={{ maxWidth: "100px" }}
                                  />
                                </div>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col> */}
                    </Row>
                    {intakeDirectionFields.length > 1 && (
                      <button
                        className="mt-3 add-varient"
                        type="button"
                        onClick={() => removeIntakeDirection(index)} // Remove the variant
                      >
                        Remove Intake Direction
                      </button>
                    )}
                    <hr />
                  </div>
                ))}
              </div>
              <hr />
              <div className="text-center">
                <button
                  type="button"
                  className="add-varient"
                  onClick={() => appendIntakeDirection({})}
                >
                  + Add Intake Direction
                </button>
              </div>
            </div>

            <hr />

            <Row className="mt-5 pb-3">
              <div className="d-flex justify-content-center">
                <Link to={"/subscription/plans"}>
                  <CancelButton
                    name={"cancel"}
                    handleClose={props.handleClose}
                  />
                </Link>

                <SaveButton
                  name={"save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </div>
            </Row>
          </Row>
        </Form>
      </section>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
